export enum CampaignPage {
    campaignType        = 1,    // Campaign Type Selection
    campaignImage       = 2,    // Social Media Campaign Image (injected into the social media post)
    campaignLocationMap = 3,    // Location Campaign Map (used to define the geofence coordinates)
    campaignPosterMap   = 4,    // Poster Campaign Map (used to define the poster coordinates)
    campaignDateTime    = 5,    // Campaign Date Time Selection
    campaignRate        = 6,    // Campaign Rate Selection
    campaignReview      = 7,    // Campaign Review & Confirm
}
